module.exports = __webpack_public_path__ + "static/media/babushkam.b4b1fe86.png";